export default __webpack_public_path__ + "static/avatar-kayi-common-3-detail-d6888b6c2f75b71c01dc19cc83317fa3.png";